import { useEffect, useState } from 'react';
import { listAccountMembers } from '../services/accountService';

export const useAccountMembers = (accountId) => {
  const [state, setState] = useState({ accountId: null, members: [], error: null });
  useEffect(() => {
    let active = true;
    if (!accountId) { setState({ accountId: null, members: [], error: null }); return () => { active = false; }; }
    listAccountMembers(accountId).then((members) => {
      if (active) setState({ accountId, members, error: null });
    }).catch((error) => {
      if (active) setState({ accountId, members: [], error });
    });
    return () => { active = false; };
  }, [accountId]);
  return state.accountId === accountId ? state : { accountId, members: [], error: null };
};
